import i18n from "../../services/i18n";

import { AssetTypes, ExperienceLevel } from "common/utils/types";
import { countryList } from "./countryList";
import { defaultCountryAutocompleteOption } from "../../utils/utility";

const CountriesOptions = (): any => {
  let options = countryList("eu");
  options.push(defaultCountryAutocompleteOption);
  return options;
};

export const AutocompleteOptions = () => {
  return {
    countries: CountriesOptions(),
    educationLevel: [
      { label: i18n.t("Primary education"), code: 1 },
      { label: i18n.t("Secondary education"), code: 2 },
      { label: i18n.t("Academic degree"), code: 3 },
      { label: i18n.t("Professional development"), code: 4 },
      { label: i18n.t("Other"), code: 5 },
    ],
    occupationGroup: [
      { label: i18n.t("Employee"), code: 1 },
      { label: i18n.t("Civil servant"), code: 2 },
      { label: i18n.t("Self-employed"), code: 3 },
      { label: i18n.t("Student"), code: 4 },
      { label: i18n.t("Pensioner"), code: 5 },
      { label: i18n.t("Apprentice"), code: 6 },
      { label: i18n.t("Privatier"), code: 7 },
    ],
  };
};

export const SelectOptions = () => {
  return {
    asset: [
      { label: i18n.t("Real Estate"), value: AssetTypes.REAL_ESTATE },
      { label: i18n.t("Loan"), value: AssetTypes.LOAN },
    ],
    experience: [
      { label: i18n.t("Non"), value: ExperienceLevel.none },
      { label: i18n.t("Up to 3 years"), value: ExperienceLevel.low },
      { label: i18n.t("3 to 5 years"), value: ExperienceLevel.medium },
      { label: i18n.t("More than 5 years"), value: ExperienceLevel.high },
    ],
    gender: [
      { label: i18n.t("Male"), value: 1 },
      { label: i18n.t("Female"), value: 2 },
    ],
    idType: [
      { label: i18n.t("ID"), value: 1 },
      { label: i18n.t("Passport"), value: 2 },
    ],
    increaseLimit: [
      { label: i18n.t("10% of available cash"), value: 1, id: "availableCash" },
      { label: i18n.t("Double of monthly NET salary" ), value: 2, id: "monthlySalary" },
    ],
    paymentMethod: [
      { label: i18n.t("Credit Card"), value: "Credit Card", disabled: true },
      { label: i18n.t("SEPA Direct Debit"), value: "SEPA Direct Debit", disabled: true },
      { label: i18n.t("Wire Transfer"), value: "Wire Transfer" },
    ],
    yesNo: [
      { label: i18n.t("Yes"), value: true },
      { label: i18n.t("No"), value: false },
    ],
  };
};
